import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import loginLogo from "../../../assets/img/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../../provider/AuthContext";
import apiCall from "../../Api/api";
import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";
import { useToast } from "provider/ToastProvider";
import { ToastContainer } from "react-toastify";

const Login = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const referrer = queryParams.get("referrer") || "/";
  const [show, setShow] = useState(true);
  const { login, isLoggedIn } = useAuth();
  const { showErrorToast } = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedIn) {
      navigate(referrer);
    }
  }, [isLoggedIn, navigate, referrer]);


  const handleClose = () => setShow(false);

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      if (!credentialResponse?.credential) {
        console.error("No credential received from Google");
        return;
      }

      const googleToken = credentialResponse.credential;
      const decoded = jwtDecode(googleToken);
      const { email, name, sub } = decoded || {};
      if (!email || !name || !sub) {
        console.error("Missing required fields from Google token");
        return;
      }

      const formData = new FormData();
      formData.append("email", email);
      formData.append("name", name);
      formData.append("source", "google");
      formData.append("source_id", sub);

      const loginRes = await apiCall({
        url: "social-login",
        method: "POST",
        data: formData,
      });

      if (loginRes.status !== 200) {
        throw new Error(`Unexpected status code: ${loginRes.status}`);
      }
      if (loginRes.status === 200 && loginRes.data?.access_token) {
        const accessToken = loginRes.data.access_token;
        // const accessToken = 'cebb9d927a68cc3c96112336e550316b6b55538f3663aa66ec6621daea15f62d96f29f7cb3c46031726d34df8743ed5ac719841c6e260956e8b3d8bc90f3853c';


        // Store token immediately
        Cookies.set("auth_token", accessToken, {
          expires: 7,
          secure: true,
          sameSite: "Strict",
        });


        // Fetch profile using token
        const profileRes = await apiCall({
          url: "profile",
          method: "GET",
          token: accessToken,
        });

        if (profileRes.status === 200 && profileRes.data?.user) {
          const user = profileRes.data.user;


          login(user, accessToken);
          setShow(false);
          navigate(referrer);
        } else {
          console.error("Failed to fetch user profile", profileRes.data);
        }
      } else {
        console.error("Login failed", loginRes.data);
      }
    } catch (error) {
      console.error("Google login error:", error.response?.data || error.message);
      showErrorToast(error.response?.data || error.message)
    }
  };

  return (
    <>
      {!isLoggedIn && <><div className="terms-contionsSplasescreen"></div>

        <Modal
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          centered
          size="md"
          scrollable
        >
          <Modal.Header className="justify-content-center">
            <h1 className="modal-title fs-5">
              <img src={loginLogo} alt="logo" width="180px" className="logo" />
            </h1>
          </Modal.Header>

          <Modal.Body className="px-5">
            <div className="row py-4">
              <div className="col-12 logindesign">
                <div className="content_terms">
                  <h5 className="text-center">Login to your account</h5>
                  <div className="pt-3 d-flex justify-content-center">
                    <GoogleLogin
                      onSuccess={handleGoogleSuccess}
                      onError={() => console.error("Google login failed")}
                    />
                  </div>
                  <div className="contenss pt-3">
                    <p className="text-center mb-0">
                      By logging in, you agree to our <br />
                      <Link to="/terms-of-use" target="_blank">
                        Terms of Use
                      </Link>{" "}
                      and{" "}
                      <Link to="/privacy-policy" target="_blank">
                        Privacy Policy
                      </Link>
                      .
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
         <ToastContainer
                position="top-center"
              />
      </>
      }
    </>
  );
};

export default Login;
